export default {"src":"/_next/static/media/customer.090bc9eb.svg","height":26,"width":26};